bovoApp.controller('CustomerNewOrderController',
    ['$scope', '$location', '$rootScope', 'User', '$timeout', 'Order', 'CustomerOrder', 'FileUploader', '$filter', '$http', '$routeParams',
        function ($scope, $location, $rootScope, User, $timeout, Order, CustomerOrder, FileUploader, $filter, $http, $routeParams) {
            $rootScope.proccesCount = 1;

            $scope.newOrderData = {
                type: 1,
                address: {},
                scheduled_time: '',
                status: 2,
                location: {},
                order_payment: 'offline',
                payment_type: 'credit_card',
                flexible_date: 0,
                referance_number_remember: false,
                waybill_number_remember: false,
                personal_number_remember: false,
                work_type: 1,
                buyer_pay: 0,
                use_title: 0,
                use_address: 0,
                location_invoice: {},
                additional_info: {
                    length: null,
                    height: null,
                    width: null,
                },
                items: [{
                    weight: null,
                }]
            };

            $scope.packageTypes = [
                {
                    id: 1,
                    name: 'Evrak',
                },
                {
                    id: 2,
                    name: 'Paket',
                },
                {
                    id: 3,
                    name: 'Koli',
                }
            ];

            $scope.startMarker = null;
            $scope.endMarker = null;

            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                administrative_area_level_2: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            };

            var mapping = {
                street_number: 'number',
                route: 'street',
                locality: 'city',
                administrative_area_level_1: 'state',
                administrative_area_level_2: 'district',
                country: 'country',
                postal_code: 'zip'
            };

            $scope.$on('city_selected', function (event, data) {
                $scope.newOrderData.location.city = data.name
            }, true);

            $scope.$on('district_selected', function (event, data) {
                $scope.newOrderData.location.district = data.name
                $scope.newOrderData.location.state = data.name
            }, true);

            $scope.calculateDesi = function() {
                if ($scope.newOrderData.additional_info.width && 
                    $scope.newOrderData.additional_info.length && 
                    $scope.newOrderData.additional_info.height) {
                        
                    var desi = ($scope.newOrderData.additional_info.width * 
                                $scope.newOrderData.additional_info.length * 
                                $scope.newOrderData.additional_info.height) / 3000;
                                
                    $scope.newOrderData.weight = parseFloat(desi.toFixed(2));
                } else {
                    $scope.newOrderData.weight = null;
                }
            };

            $scope.init = function () {
                CustomerOrder.newOrderData().success(function (data) {
                    $scope.orderData = data;
                    $scope.tempOrderData = $scope.newOrderData;
                    $scope.newOrderData = {
                        type: 1,
                        address: {},
                        scheduled_time: '',
                        status: 2,
                        location: {},
                        order_payment: 'offline',
                        payment_type: 'credit_card',
                        flexible_date: 0,
                        buyer_pay: 0,
                        use_title: 0,
                        use_address: 0,
                        location_invoice: {},
                        items: [{
                            weight: null,
                        }],
                        work_type: $scope.orderData.workTypes[0].id
                    };

                    if ($scope.tempOrderData.referance_number_remember) {
                        $scope.newOrderData.referance_number_remember = true;
                        $scope.newOrderData.referance_number = $scope.tempOrderData.referance_number;
                    }

                    if ($scope.tempOrderData.waybill_number_remember) {
                        $scope.newOrderData.waybill_number_remember = true;
                        $scope.newOrderData.waybill_number = $scope.tempOrderData.waybill_number;
                    }

                    if ($scope.tempOrderData.personal_number_remember) {
                        $scope.newOrderData.personal_number_remember = true;
                        $scope.newOrderData.personal_number = $scope.tempOrderData.personal_number;
                    }

                    createMapCustomer()

                    if ($routeParams.return) {
                        $rootScope.returnOrder = true;
                        $scope.newOrderData.delivery_type = {
                            delivery_type: 'return'
                        }
                        // $scope.newOrderData.work_type = 100;
                    } else {
                        $rootScope.returnOrder = false;
                        $scope.newOrderData.work_type = 1;
                    }

                    if ($routeParams.order_id) {
                        Order.order($routeParams.order_id).success(function (data, status, headers, config) {
                            $scope.newOrderData = data.order
                            $scope.newOrderData.work_type = data.order.work_type ? data.order.work_type.id : $scope.orderData.workTypes[0].id;
                            $scope.locationSelectedCustomer(data.order.location, 'order')
                            if ($scope.newOrderData.location.city_id) {
                                $scope.newOrderData.location.city_id = $scope.newOrderData.location.city_id.toString();
                                setTimeout(function () {
                                    $scope.newOrderData.location.city_id = $scope.newOrderData.location.city_id.toString();
                                    $scope.$apply();
                                }, 300);
                            }
                            if ($scope.newOrderData.location.district_id) {
                                $scope.newOrderData.location.district_id = $scope.newOrderData.location.district_id.toString();
                            }
                            $scope.getAllDistricts($scope.newOrderData.location.city_id)
                        });
                    }
                });
            }


            $rootScope.print = false

            $scope.printControl = function () {
                $rootScope.print = !$rootScope.print
            }

            $scope.printBarcode = function (zpl, orderId, weight) {
                /* if(!localStorage.getItem("printerName")) {
                    alert('Yazıcı Adı girip kaydetmeniz gerekmektedir!');
                    return true;
                } */
                var config = qz.configs.create(localStorage.getItem("printerName"));
                var data = [];   // Raw commands (ZPL provided)
                zpl = JSON.parse(zpl)
                // zpl.forEach(element => {
                //     data.push(element);
                // });
                console.log(data);
                qz.print(config, zpl).then(function () {
                    console.log("Sent data to printer");
                    $scope.cleanInput();
                    // updateStatus(orderId, weight);
                });
            }

            $scope.updateStatus = function (orderId, weight) {
                $.post({
                    url: "/update-mng-status",
                    data: {
                        orderId: orderId,
                        weight: weight
                    },
                    success: function (data) {
                        console.log(data)
                    },
                    error: function (data, xhr) {
                        console.log(data)
                    }
                });
            }
            $scope.cleanInput = function () {
                $("#orderId").removeAttr("disabled");
                $("#orderId").val('');
                $("#orderId").focus();
            }

            $scope.startConnection = function (config) {
                if (!qz.websocket.isActive()) {
                    $scope.updateState('Bekleniyor...', 'default');

                    qz.websocket.connect(config).then(function () {
                        $scope.updateState('Active', 'success');
                        $scope.findPrinters();
                        // cleanInput();
                    }).catch($scope.handleConnectionError());
                } else {
                    $scope.displayMessage('Bağlantı aktif.', 'alert-warning');
                }
            }
            $scope.displayMessage = function (msg, css) {
                Messenger().post({ message: msg, type: "warning" });
            }

            $scope.findPrinters = function () {
                qz.printers.find().then(function (data) {
                    console.log(data)
                    $('#printerName')
                        .find('option')
                        .remove()
                        .end()
                        .append('<option value="">Seçim Yapınız</option>')
                        .val('whatever');
                    for (var i = 0; i < data.length; i++) {
                        $scope.addOption(data[i])
                    }
                    $scope.displayMessage("Yazıcı listesi güncellendi");
                    if (localStorage.getItem("printerName")) {
                        let element = document.getElementById('printerName');
                        element.value = localStorage.getItem("printerName");
                    }
                }).catch(function (e) { console.error(e); });
            }

            $scope.setPrinterName = function (value) {
                if (value) {
                    var name = value;
                } else {
                    var name = $.trim($("#printerName").val());
                }
                localStorage.setItem("printerName", name);
                Messenger().post('Yazıcı Kaydedildi');
            }
            $scope.addOption = function (value) {
                var x = document.getElementById("printerName");
                var option = document.createElement("option");
                option.value = value;
                option.text = value;
                x.add(option);
            }

            $scope.updateState = function (text, css) {
                $("#qz-status").html(text);
            }

            $scope.setDeliveryType = function (order) {
                if($scope.newOrderData.delivery_type.delivery_type == 'delivery') {
                    $scope.newOrderData.delivery_type.return_type = null;
                    $scope.newOrderData.work_type = 1
                }
                if($scope.newOrderData.delivery_type.delivery_type == 'store_transfer') {
                    $scope.newOrderData.work_type = 7;
                    $scope.newOrderData.piece = 1;
                }
                if($scope.newOrderData.delivery_type.delivery_type == 'return' && $scope.newOrderData.delivery_type.return_type == 'return_station') {
                    $scope.newOrderData.work_type = 100
                }
                if($scope.newOrderData.delivery_type.delivery_type == 'return' && $scope.newOrderData.delivery_type.return_type == 'return_door') {
                    $scope.newOrderData.work_type = 115
                }
                if($scope.newOrderData.delivery_type.delivery_type == 'store_return') {
                    $scope.newOrderData.location.address = 'Ömerli Mh, İhsangazi Sk. No:21   Karaca Omerli 2 deposu -1 kati';
                    $scope.newOrderData.location.city = 'İstanbul';
                    $scope.newOrderData.location.district = 'Arnavutköy';
                    $scope.newOrderData.location.city_id = "34";
                    $scope.newOrderData.location.phone_number = '5314305317';
                    $scope.getAllDistricts($scope.newOrderData.location.city_id)
                    $scope.newOrderData.location.district_id = "2048";
                    $scope.newOrderData.location.name = 'KARACA 3S DEPO İADE';
                    $scope.newOrderData.location.neighborhood = 'Ömerli Mh';
                }
            }

            $scope.fillStoreCustomer = function () {
                $scope.storeCustomer = JSON.parse($scope.newOrderData.store_customer);
                $scope.newOrderData.location.name = $scope.storeCustomer.customer_name;
                $scope.newOrderData.location.city = $scope.storeCustomer.city;
                $scope.newOrderData.location.city_id = $scope.storeCustomer.city_id.toString();
                $scope.getAllDistricts($scope.newOrderData.location.city_id)
                $scope.newOrderData.location.state = $scope.storeCustomer.district;
                $scope.newOrderData.location.district = $scope.storeCustomer.district;
                $scope.newOrderData.location.district_id = $scope.storeCustomer.district_id.toString();
                $scope.newOrderData.location.neighborhood = $scope.storeCustomer.neighborhood;
                $scope.newOrderData.location.address = $scope.storeCustomer.address;
                $scope.newOrderData.location.zipcode = $scope.storeCustomer.zipcode;
                $scope.newOrderData.location.latitude = $scope.storeCustomer.latitude;
                $scope.newOrderData.location.longitude = $scope.storeCustomer.longitude;
                $scope.newOrderData.location.phone_number = $scope.storeCustomer.phone_number;
            }

            $scope.handleConnectionError = function (err) {
                $scope.updateState('Bağlantı Hatası', 'danger');

                if (err.target != undefined) {
                    if (err.target.readyState >= 2) { //if CLOSING or CLOSED
                        $scope.displayError("QZ bağlantısı sonlandırıldı.");
                    } else {
                        $scope.displayError("Bağlantı sağlanırken bir hata oluştu.");
                        console.error(err);
                    }
                } else {
                    $scope.displayError(err);
                }
            }

            $scope.displayError = function (err) {
                console.error(err);
                $scope.displayMessage(err, 'alert-danger');
            }

            $scope.submitNewOrder = function () {
                if (!$scope.newOrderData.location.name) {
                    $('.location-name input').focus();
                } else {
                    setTimeout(() => {
                        document.getElementById('newWorkBtn').click()
                    }, 300);
                }
            }

            $scope.addBox = function () {
                $scope.newOrderData.items.push({
                    weight: null,
                });
            }

            $scope.removeBox = function (index) {
                $scope.newOrderData.items.splice(index, 1);
            }

            $scope.handlePiece = function () {
                console.log($scope.newOrderData.piece);
                if ($scope.newOrderData.piece) {
                    $scope.newOrderData.items = [];
                    for (let index = 0; index < $scope.newOrderData.piece; index++) {
                        $scope.addBox();
                    }
                }
            }

            $scope.handleWeight = function () {
                var weight = $scope.newOrderData.weight / $scope.newOrderData.items.length
                $scope.newOrderData.items.forEach(element => {
                    element.weight = weight
                });
            }

            $scope.useUp = function (type) {
                if (type == 'use_title') {
                    if ($scope.newOrderData.use_title) {
                        $scope.newOrderData.use_title = false
                    } else {
                        $scope.newOrderData.use_title = true
                    }
                }
                if (type == 'use_address') {
                    if ($scope.newOrderData.use_address) {
                        $scope.newOrderData.use_address = false
                    } else {
                        $scope.newOrderData.use_address = true
                    }
                }

                if (type == 'use_title' && $scope.newOrderData.use_title) {
                    $scope.newOrderData.location_invoice.title = $scope.newOrderData.location.name
                } else if (type == 'use_title' && !$scope.newOrderData.use_title) {
                    $scope.newOrderData.location_invoice.title = ''
                }

                if (type == 'use_address' && $scope.newOrderData.use_address) {
                    $scope.newOrderData.location_invoice.address = $scope.newOrderData.location.address
                } else if (type == 'use_address' && !$scope.newOrderData.use_address) {
                    $scope.newOrderData.location_invoice.address = ''
                }

            }

            $scope.newCustomerOrder = function (newWork) {
                if (newWork) {
                    $scope.disabledBtn = true;
                    CustomerOrder.newCustomerOrder($scope.newOrderData).success(function (data, status, headers, config) {
                        $rootScope.newOrder = data;
                        $rootScope.newOrderText = 'Kargo NO : ' + $rootScope.newOrder.id
                        if($scope.newOrderData.work_type == 100) {
                            $rootScope.newOrderText += ' <br> Kargo İade Kodu : ' + data.mng_return_order_map.rma_code  + ' <br> DHL Cari Kodu: ' + data.mng_return_order_map.customer_number;
                        }
                        if($scope.newOrderData.work_type == 115) {
                            $rootScope.newOrderText += ' <br> Kargo İade Kodu : ' + $rootScope.newOrder.id;
                            if($rootScope.newOrder.scheduled_time) {
                                $rootScope.newOrderText += ' <br> Kapıdan Alım Tarihi : ' + moment($rootScope.newOrder.scheduled_time && $rootScope.newOrder.scheduled_time?.date ? $rootScope.newOrder.scheduled_time.date : $rootScope.newOrder.scheduled_time).format('DD/MM/YYYY');
                            }else {
                                $rootScope.newOrderText += ' <br> Kapıdan Alım Tarihi : ' + moment().add(1, 'days').format('DD/MM/YYYY');
                            }
                        }

                        $('#successBox').modal('show');
                        $scope.init();
                        $scope.disabledBtn = false;
                        // $scope.getOrderDetails(data);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                        $scope.disabledBtn = false;
                    });
                }
            }

            $scope.updateOrder = function (newWork) {
                $scope.disabledBtn = true;
                CustomerOrder.updateCustomerOrder($scope.newOrderData).success(function (data, status, headers, config) {
                    Messenger().post('Başarıyla Güncellendi!');
                    $scope.disabledBtn = false;
                    $rootScope.newOrder = data;
                    $rootScope.newOrderText = 'Kargo No : ' + $rootScope.newOrder.id
                    if($scope.newOrderData.work_type == 100) {
                        $rootScope.newOrderText += ' <br> Kargo İade Kodu : ' + data.mng_return_order_map.rma_code  + ' <br> DHL Cari Kodu: ' + data.mng_return_order_map.customer_number;;
                    }
                    $('#successBox').modal('show');
                    $rootScope.procces = 'update';
                    $scope.init();
                }).error(function (data) {
                    $scope.disabledBtn = false;
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $scope.locationSelectedCustomer = function (selected, type) {
                if (typeof type === 'undefined') {
                    if (typeof selected !== 'undefined') {
                        var customer = selected.originalObject;
                    } else {
                        var customer = [];
                    }
                } else {
                    var customer = selected;
                }

                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    var location = new google.maps.LatLng(customer.latitude, customer.longitude);
                    setTimeout(function () {
                        // $scope.searchMap.setCenter(location);
                        // $scope.marker.setDuration(1000);
                        // $scope.marker.setEasing("swing");
                        // $scope.marker.setPosition(location);
                        angular.merge($scope.newOrderData.location, customer);
                        $scope.newOrderData.location.city = customer.city;
                        $scope.newOrderData.location.state = customer.state;
                        if (type && type == 'search') {
                            var address = ''
                            if (customer.street) {
                                address += customer.street + ' '
                            }
                            if (customer.number) {
                                address += 'No:' + customer.number + ' '
                            }
                            $scope.newOrderData.location.address = address;
                        } else {
                            $scope.newOrderData.location.address = customer.address;
                        }
                        $scope.newOrderData.location.zipcode = customer.zipcode ? customer.zipcode : customer.zip;
                        $scope.states.forEach(element => {
                            if (element.abbreviation == customer.city) {
                                $scope.newOrderData.location.state = element.name;
                                return true;
                            }
                        });

                        if ($scope.newOrderData.location.city_id) {
                            $scope.newOrderData.location.city_id = $scope.newOrderData.location.city_id.toString();
                            setTimeout(function () {
                                $scope.newOrderData.location.city_id = $scope.newOrderData.location.city_id.toString();
                                $scope.$apply();
                            }, 300);
                        }

                        if ($scope.newOrderData.location.district_id) {
                            $scope.newOrderData.location.district_id = $scope.newOrderData.location.district_id.toString();
                        }
                        $scope.getAllDistricts($scope.newOrderData.location.city_id)
                        $scope.$apply();

                    }, 300);
                }
            }

            function createMapCustomerOld() {
                var location = new google.maps.LatLng(Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon));
                setTimeout(function () {
                    $scope.searchMap = new google.maps.Map(document.getElementById('customerMapOrder'), {
                        zoom: 11,
                        center: location,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        disableDefaultUI: true,
                        styles: [{
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#f5f5f5"
                            }]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [{
                                "visibility": "off"
                            }]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#616161"
                            }]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [{
                                "color": "#f5f5f5"
                            }]
                        },
                        {
                            "featureType": "administrative.land_parcel",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#bdbdbd"
                            }]
                        },
                        {
                            "featureType": "landscape.natural",
                            "elementType": "geometry.stroke",
                            "stylers": [{
                                "color": "#4247bd"
                            }]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#eeeeee"
                            }]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#757575"
                            }]
                        },
                        {
                            "featureType": "poi.business",
                            "stylers": [{
                                "visibility": "off"
                            }]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#e5e5e5"
                            }]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "labels.text",
                            "stylers": [{
                                "visibility": "off"
                            }]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#9e9e9e"
                            }]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#ffffff"
                            }]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#757575"
                            }]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#dadada"
                            }]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#616161"
                            }]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#9e9e9e"
                            }]
                        },
                        {
                            "featureType": "transit.line",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#e5e5e5"
                            }]
                        },
                        {
                            "featureType": "transit.station",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#eeeeee"
                            }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [{
                                "color": "#c9c9c9"
                            }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry.fill",
                            "stylers": [{
                                "color": "#bdd1e8"
                            }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#9e9e9e"
                            }]
                        }
                        ]
                    });

                    $scope.marker = new SlidingMarker({
                        position: location,
                        map: $scope.searchMap,
                        visible: true,
                        draggable: true,
                        icon: '/img/map-pin.png'
                    });


                    if (navigator.geolocation && !$scope.newOrderData.id) {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            var location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                            // $scope.marker.setPosition(location)
                            // $scope.searchMap.setCenter(location)
                        });
                    } else {
                        console.log("Geolocation is not supported by this browser.");
                    }

                    var input = document.getElementById('googlePlaceInput');
                    google.maps.event.addDomListener(input, 'keydown', function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        }
                    });

                    $scope.marker.addListener('dragend', function (event) {

                        var latlng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
                        var geocoder = new google.maps.Geocoder();

                        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    var place = results[0];
                                    var details = place.geometry && place.geometry.location ? {
                                        latitude: place.geometry.location.lat(),
                                        longitude: place.geometry.location.lng()
                                    } : {};
                                    for (var i = 0; i < place.address_components.length; i++) {
                                        var addressType = place.address_components[i].types[0];
                                        if (componentForm[addressType]) {
                                            var val = place.address_components[i][componentForm[addressType]];
                                            details[mapping[addressType]] = val;
                                        }
                                    }
                                    details.formatted = place.formatted_address;
                                    details.placeId = place.place_id;
                                    details.address = place.formatted_address;
                                    angular.merge($scope.newOrderData.location, details);
                                    $scope.newOrderData.location.city = details.state;
                                    $scope.newOrderData.location.state = details.district;
                                    var address = ''
                                    if (details.street) {
                                        address += details.street + ' '
                                    }
                                    if (details.number) {
                                        address += 'No:' + details.number + ' '
                                    }
                                    $scope.newOrderData.location.address = address;
                                    $scope.newOrderData.location.zipcode = details.zipcode ? details.zipcode : details.zip;
                                    $scope.$apply();
                                }
                            }
                        });
                    });
                }, 300);
            }

            $scope.selectedAddress = async function (selected) {
                var city = selected.description.city
                var district = selected.description.district


                $scope.newOrderData.location.district = await district
                $scope.newOrderData.location.city = await city

            }
            function createMapCustomer() {
                if (typeof $scope.searchMap !== 'undefined') {
                    return;
                }
                var location = [Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon)]
                $scope.searchMap = L.map('customerMapOrder', {
                    maxZoom: 18,
                    minZoom: 6
                }).setView(location, 12);

                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo($scope.searchMap);

                $scope.marker = L.marker(location, {
                    draggable: true,
                });
                $scope.marker.on('dragend', function (event) {
                    var marker = event.target;
                    var position = marker.getLatLng();
                    marker.setLatLng(new L.LatLng(position.lat, position.lng), { draggable: 'true' });
                    $scope.searchMap.panTo(new L.LatLng(position.lat, position.lng))

                    Order.reverseGeo({ latitude: position.lat, longitude: position.lng }).success(function (data, status, headers, config) {
                        if (data.length > 0) {
                            angular.merge($scope.newOrderData.location, {
                                address: data[0].ANNAME + ' ' + data[0].ADI + ' ' + data[0].SAG_MAH,
                                city: data[0].SAG_IL,
                                state: data[0].SAG_ILCE,
                                latitude: data[0].CENT.LatY,
                                longitude: data[0].CENT.LongX
                            });
                            setTimeout(() => {
                                $scope.$apply();
                            }, 200);
                        }
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    });

                });
                $scope.searchMap.addLayer($scope.marker);

                if (navigator.geolocation && !$scope.newOrderData.id) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var location = new L.LatLng(position.coords.latitude, position.coords.longitude);
                        $scope.marker.setLatLng(location);
                        $scope.searchMap.panTo(location)
                    });
                } else {
                    console.log("Geolocation is not supported by this browser.");
                }
            }
        }
    ]);